const {TOKEN_TTL_SECONDS} = require("../constants/tokenTtl");

const CLOCK_SKEW_TOLERANCE_MS = 60 * 1000;

const getInitials = (fullName) => {
  if (!fullName) return "";
  const parts = fullName.trim().split(/\s+/); // Elimina espacios en blanco adicionales
  const initials = parts[0]?.charAt(0) + (parts[1]?.charAt(0) || "");
  return initials.toUpperCase();
};

const getColorFromName = (name, colors) => {
  if (!colors.length) return "#FFFFFF";
  if (name === "" || name == null) return colors[0];
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % colors.length;
  return colors[index];
};

const toLocalDate = (date) => {
  if (!date) return "";
  const localDate = new Date(date);
  const day = String(localDate.getDate()).padStart(2, "0");
  const month = String(localDate.getMonth() + 1).padStart(2, "0");
  const year = localDate.getFullYear();
  const hours = String(localDate.getHours()).padStart(2, "0");
  const minutes = String(localDate.getMinutes()).padStart(2, "0");
  return `${day}/${month}/${year} ${hours}:${minutes}`;
};
const toDate = (value) => {
  if (value === null || value === undefined || value === "") return null;

  if (typeof value === "number" || /^\d+$/.test(String(value).trim())) {
    const epoch = Number(value);
    const date = new Date(epoch < 1e11 ? epoch * 1000 : epoch);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};
const getTokenIssuedAt = (token) => {
  const stored = toDate(token?.created_at ?? token?.issued_at);
  if (stored) return {issuedAt: stored.toISOString(), estimated: false};

  // El tipo llega del backend, así que se normaliza antes de buscar su TTL.
  const type = typeof token?.type === "string" ? token.type.trim().toLowerCase() : null;
  const ttlSeconds = TOKEN_TTL_SECONDS[type];
  const expiresAt = toDate(token?.expires_at);
  if (ttlSeconds && expiresAt) {
    const issuedAt = new Date(expiresAt.getTime() - ttlSeconds * 1000);
    const MAX_REASONABLE_AGE_MS = 7 * 24 * 60 * 60 * 1000; // 7 días

    if (
      issuedAt.getTime() >= Date.now() - MAX_REASONABLE_AGE_MS &&
      issuedAt.getTime() <= Date.now() + CLOCK_SKEW_TOLERANCE_MS
    ) {
      return {issuedAt: issuedAt.toISOString(), estimated: true};
    }
  }

  return {issuedAt: "", estimated: false};
};

const scopeToString = (scope) => {
  if (!scope?.resource) return "Scope";
  return [scope.product_name, scope.resource, scope.subresource, scope.ownership, scope.action]
    .filter(Boolean)
    .join(".");
};

module.exports = {getColorFromName, getInitials, toLocalDate, getTokenIssuedAt, scopeToString};
